import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { queriesStakeholders } from "@query";
import { ErrorAlert } from "@components/ErrorAlert";

type Props = {
  stakeholderId: string;
  accountId: string;
} & WSModalCustomProps<boolean>;

const ModalRevokeStakeholder: React.FC<Props> = props => {
  const [revokeStakeholder, revokeStakeholderMeta] =
    queriesStakeholders.revokeStakeholder.useMutation();

  return (
    <WSModal
      title="Are you sure you want to remove this team member?"
      size="S"
      onClose={props.onClose}
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Tertiary",
            label: "Cancel",
            type: "button",
            onClick: () => props.onClose(false)
          },
          {
            kind: "Primary",
            destructive: true,
            label: "Remove team member",
            loading: revokeStakeholderMeta.isLoading,
            onClick: async () => {
              await revokeStakeholder(
                {
                  accountId: props.accountId,
                  stakeholderId: props.stakeholderId
                },
                { throwOnError: true }
              );
              props.onClose(true);
            }
          }
        ]
      }}
    >
      <WSList gap="M">
        <WSText>Once confirmed, this action cannot be undone.</WSText>
        <ErrorAlert
          error={revokeStakeholderMeta.error}
          context="TeamStakeholder"
        />
      </WSList>
    </WSModal>
  );
};

export const useModalRevokeStakeholder = () =>
  useWSModalCustom(ModalRevokeStakeholder);
